import _ from 'lodash'
// import { fmtPercent } from '@com/utils/data-format.js'
import { channelList } from '@com/utils/channel'
import {
  mwsAccountTypeList,
  statusOptions,
  GrantTypeLabel,
} from '@/common/permission'

export default {
  computed: {
    channelList() {
      return channelList
    },

    dataFormat() {
      return [
        'template_cnt',
        'project_cnt',
        'normal_cnt',
        'mgroup_cnt',
        'dco_cnt',
        'ps_cnt',
        'download_cnt',
        'push_cnt',
        'reduce_cnt',
        'total_cnt',
        'mintegral_cnt',
        'mintegral_push_cnt',
        'facebook_cnt',
        'google_cnt',
        'applovin_cnt',
        'ironsource_cnt',
        'ocean_engine_cnt',
        'pangle_cnt',
        'vungle_cnt',
        'ks_cnt',
        'kwai_cnt',
        'ams_cnt',
        'gdt_cnt',
        'adcolony_cnt',
        'other_cnt',
      ]
    },

    notAllowSortColumn() {
      // 禁止排序字段
      return [
        'adv_name',
        'is_test',
        'login_days',
        'active_days',
        'last_login_time',
        'account_type',
        'subscribe_type',
        'is_all_channel',
        'android_package_name',
        'android_url',
        'ios_package_name',
        'ios_url',
        'preview_url',
        'status',
        'target_adv_names',
        'effective_time',
        'expired_time',
      ]
    },
    creatFromList() {
      return [
        {
          label: '内部',
          value: 'internal',
        },
        {
          label: '客户',
          value: 'pt',
        },
      ]
    },
    projectTypeList() {
      return [
        {
          label: '普通制作',
          value: 'normal',
        },
        {
          label: '多组合制作',
          value: 'mgroup',
        },
        {
          label: 'dco制作',
          value: 'dco',
        },
        {
          label: 'ps制作',
          value: 'ps',
        },
      ]
    },
    sourceList() {
      return [
        {
          label: '定制模板',
          value: 'dm',
        },
        {
          label: '通用模板',
          value: 'gm',
        },
        {
          label: 'ps',
          value: 'ps',
        },
      ]
    },
    statusList() {
      return statusOptions
    },
    subscribeTypeList() {
      return this.dataSubscribeTypes.map((item) => {
        return {
          label: item.name,
          value: item.type,
        }
      })
    },
    accountTypeList() {
      return mwsAccountTypeList
    },
    grantTypeList() {
      return _.map(GrantTypeLabel, (v, k) => {
        return {
          label: v,
          value: Number(k),
        }
      })
    },
    pushAddDownloadList() {
      return [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 2,
        },
      ]
    },
    subscriptionProjectType() {
      return [
        {
          label: '空白制作',
          value: 'blank',
        },
        {
          label: '模版制作',
          value: 'template',
        },
      ]
    },
    subscriptionStatus() {
      return [
        {
          label: statusOptions['unactive'],
          value: 'unactive',
        },
        {
          label: statusOptions['active'],
          value: 'active',
        },
        {
          label: statusOptions['disable'],
          value: 'disable',
        },
        {
          label: statusOptions['revoked'],
          value: 'revoked',
        },
        {
          label: statusOptions['expired'],
          value: 'expired',
        },
      ]
    },
  },
  data() {
    return {
      dataSubscribeTypes: [],
    }
  },
  async mounted() {
    await this.getPackageConfig()
  },
  methods: {
    async getPackageConfig() {
      try {
        const res = await this.$store.dispatch('config/getGrantConfig')
        this.dataSubscribeTypes = _.get(res, 'subscribe_types')
      } catch (error) {
        console.log(error)
      }
    },
    getChannelLabel(ids) {
      const channel_ids = ids.split(',')
      const labelList = []
      channel_ids.forEach((channelId) => {
        const temp = this.channelList.find(
          (item) => item.value === Number(channelId),
        )
        if (temp) {
          labelList.push(temp.label)
        } else {
          labelList.push(channelId)
        }
      })
      return labelList.join() || '-'
    },
  },
}
